import { AppLink } from "@base/ui/AppLink";
import { useLatestLocalDraftId } from "@features/draft/model/useLatestLocalDraftId";

/**
 * PC 프로젝트 header의 일지 작성 버튼. 모바일 Documents의 + 버튼과 같이
 * 이 기기에 남은 최신 로컬 초안이 있으면 그 초안을 이어서 연다.
 */
export function NewDailyLogButton({ projectId }: { projectId: string }) {
  const latestLocalDraftId = useLatestLocalDraftId(Number(projectId));

  return (
    <AppLink
      to="/projects/$projectId/log/new"
      params={{ projectId }}
      search={latestLocalDraftId ? { draftId: latestLocalDraftId } : {}}
      className="inline-flex items-center px-4 h-10 text-white bg-blue-500 rounded-8 text-label2 hover:bg-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500"
    >
      New Daily Log
    </AppLink>
  );
}
